<style lang="scss" scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-navigation-bar;

  width: 100%;
}

.license {
  padding: 0.2rem 0.2rem 0;

  background: #fff;
  & > img {
    width: 100%;
  }
}
.list {
  margin: 0.16rem /* 8/50 */ 0;

  background-color: #fff;

  li {
    display: flex;

    position: relative;

    min-height: 0.94rem /* 47/50 */;
    padding: 0 0.32rem /* 16/50 */;

    justify-content: space-between;
    align-items: center;

    flex-flow: row nowrap;

    overflow-x: hidden;

    &:after {
      display: block;

      position: absolute;
      bottom: 0;
      left: 0.32rem;

      width: calc(100% - 0.32rem);
      height: 1px;

      background-color: #ddd;
      opacity: 0.4;

      content: '';
    }

    &:last-child {
      &:after {
        display: none;
      }
    }

    p.label {
      width: 6.4em;

      flex: none;

      font-size: 0.28rem /* 14/50 */;
      text-align: left;
      color: #666;
    }

    p.value {
      overflow: hidden;

      flex: auto;

      font-size: 0.28rem /* 14/50 */;
      text-align: right;
      white-space: nowrap;
      color: #999;

      text-overflow: ellipsis;

      img {
        width: 4.24rem /* 212/50 */;
        margin: 0.28rem /* 14/50 */ 0;
      }
    }
  }
}

p.remark {
  padding: 0.32rem /* 16/50 */;

  font-size: 0.24rem /* 12/50 */;
  color: #666;
}
.verify-btn {
  margin: 2rem auto 0;
  padding: 0 0.4rem;

  background-color: #0daf52;
  border-radius: 0.88rem;

  font-size: 0.3rem;
  line-height: 0.88rem;
  text-align: center;
  color: #fff;
}
</style>

<template>
  <page
    :custom-style="{
      display: 'flex',
      'flex-direction': 'column',
      'background-color': '#fff',
      height: '100vh',
      'padding-top': pagePaddingTop
    }"
  >
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      :safe-top-distance="statusBarHeight"
      class="nav-bar"
      left-arrow
      :title="titleName"
      @click-left="goBack"
    />
    <scroll-view v-show="verifySuccess" :background="'#F5F5F5'">
      <p class="license">
        <template v-if="license.picList && license.picList.length > 0">
          <img
            v-for="(pic, index) in license.picList"
            :key="index"
            :src="pic"
            alt="照片"
          />
        </template>
        <template v-else-if="license.pic">
          <img :src="license.pic" alt="照片" />
        </template>
      </p>
      <p v-if="type === 'biz'" class="remark">
        注：以上营业执照信息，根据国家市场监管总局《网络交易管理办法》要求对入驻商家营业执照信息进行公示，除公司名称已通过认证之外，其余信息由商家自行申报填写。如需进一步核实，请联系当地市场监督管理部门。
      </p>
      <p v-if="type === 9 || type === 2" class="remark">
        注：根据各地对于仅销售预包装食品政策的实施细则，对于平台内仅销售预包装食品的商家，应按照《电子商务法》及相关法律法规要求提供公示食品经营许可证/预包装食品销售备案文件，平台将根据商家提供的《食品经营许可证》/《销售预包装食品经营者备案信息表》/《仅销售预包装食品经营者备案信息采集表》/《备案信息截图》/《营业执照》等文件进行公示，具体文件形式以商家注册地监督管理部门要求为准。如需进一步核实，可联系商家进行咨询。
      </p>
    </scroll-view>
    <div
      v-if="!showVerify && !verifySuccess"
      class="verify-btn"
      @click="showVerify = true"
    >
      输入验证码后查看
    </div>
    <Verify
      :env="PASSPORT_GATEWAY_ENV"
      :device-id="deviceId"
      :app-key="appKey"
      :start="showVerify"
      :scene="'pop/getpopqualificationpic'"
      @callback-verified="callbackVerified"
      @callback-tracer="callbackTracer"
    ></Verify>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Verify } from '@mc/passport-h5-verify'
import { deviceId, miniProgramEnv, appKey } from '@/defines/environment'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import ScrollView from '@/common/widgets/scroll_view'
import Url from '@mc/mc-utils/js/url/url'
import { PASSPORT_GATEWAY_ENV } from '@/defines/environment/config'
export default {
  name: 'PopLicense',
  components: {
    Verify,
    ScrollView
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const { qureyId, qureyType } = vm.getUrlParams()
      vm.type = qureyType
      vm.showVerify = true
      vm.verifySuccess = false
      if (!vm.$store.state.pop.shop.id) {
        vm.$store.commit('pop/updateShopId', qureyId)
        vm.getPopShop()
      }
      tracerVuePlugin.page('#/pop_license', {
        id_type: vm.type === 'biz' || !Number(vm.type) ? 0 : Number(vm.type),
        pop_id: vm.qureyId ? Number(vm.qureyId) : 0
      })
    })
  },
  data() {
    return {
      browerInfo: window.matrix,
      type: '',
      license: {},
      showVerify: true,
      verifySuccess: false,
      deviceId: deviceId,
      appKey: appKey,
      PASSPORT_GATEWAY_ENV
    }
  },
  computed: {
    ...mapState('pop', ['shop', 'qualification']),
    titleName() {
      return this.type === 'biz' ? '营业执照' : this.license?.name
    },
    pagePaddingTop() {
      if (!miniProgramEnv.isMiniProgram) {
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    }
  },
  methods: {
    ...mapActions('pop', ['getPopShop', 'getPopQualificationPic']),
    goBack() {
      this.$back()
    },

    getUrlParams() {
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}

      const id = query.pop_id || hashQuery.pop_id || ''
      const type = query.type || hashQuery.type || ''
      return {
        qureyId: id,
        qureyType: type
      }
    },
    callbackVerified(data) {
      if (data.code !== 0) return
      this.showVerify = false
      this.verifySuccess = true
      const { qureyType } = this.getUrlParams()
      const type = qureyType === 'biz' ? -1 : this.type
      this.getPopQualificationPic({ verifyId: data.verifyId, type })
        .then(() => {
          if (qureyType === 'biz') {
            this.license = this.qualification.bizLicense
          } else {
            this.license = this.qualification.otherLicenses.find(
              license => license.type === Number(this.type)
            )
            if (!this.license) {
              return Promise.reject()
            }
          }
          const title = qureyType === 'biz' ? '营业执照' : this.license.name
          document.title = title
        })
        .catch(e => {
          this.$catch(e)
        })
    },
    callbackTracer(param) {
      if (param === 'close') {
        this.showVerify = false
      }
    }
  }
}
</script>
